import React, {Component} from 'react'
import Modal from "../Modal";
import ModalFileForm from "../../forms/file/ModalFileForm";
import PropTypes from "prop-types"

class FileModal extends Component {
    render() {
        const {id, finishCallback} = this.props;

        return <Modal id={id}>
            {(closeModal) => (
                <ModalFileForm closeModal={closeModal} finishCallback={finishCallback} />
            )}
        </Modal>
    }
}

FileModal.propTypes = {
    id: PropTypes.string.isRequired,
    finishCallback: PropTypes.func,
};

FileModal.defaultProps = {
    finishCallback: () => {},
};

export default FileModal